import React from "react";
import NavBar from "../components/NavBar";

function Header() {
  return (
    <header style={{ width: "100%" }}>
      <NavBar />
    </header>
  );
}

export default Header;
